import { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import Input from "../input/Input";
import { toast } from "react-toastify";
import { UserContext } from "../../stores/Context/Context";
import validateInput from "../../utilities/validations/validateInput";
import style from "./Registration-style.module.css";
import { preAuth } from "../../stores/slices/preAuthSlice";
import { useNavigate } from "react-router-dom";
import { language } from "../../stores/slices/languageSlice";
import { Modal } from "antd";
import {
  basicInformationDetails,
  fetchpartnerDetails,
  resetRegisterdetails,
  fetchEinDetails,
  updatePartnerFormDetails,
  loaderOpen,
  isPopupOpenReducer,
} from "../../stores/slices/einSlice";
import { resetprivacyPolicycheckbox } from "../../stores/slices/registerSlice";
import Loader from "../menu/Loader";
import { smartyStreetApi } from "../../stores/slices/smartyStreetSlice";
import { PARTNER_AUTH, PARTNER_BROWSER_ID } from "../../constant/Constants";
import stylePassword from "./password.module.css";

const BasicInfo = () => {
  let contxt = useContext(UserContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedLanguage = useSelector(language).Registrations.BasicInfo;
  const selectedLanguagePopup = useSelector(language).Registrations.RegPopu;
  const registrationDetails = useSelector((state) => state.einSlice);
  let getPartnerDetail = registrationDetails?.registerData?.partnerDetails;
  const lookUpData = useSelector((state) => state.lookupSlice);
  const errorMessage = useSelector(language).errorMessage;
  const [verifiedAddress, setVerifiedAddress] = useState({});
  let previousValue = registrationDetails?.registerData?.basicInformation;
  // const [isPopupOpen, setIsPopupOpen] = useState(
  //   registrationDetails?.registerData?.isPopupOpen
  // );
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [needHelp, setNeedHelp] = useState(false);
  // initial State value
  const [basicinfo, setBasicifo] = useState({
    EIN: {
      value: previousValue.EIN.value,
      isValid: true,
    },
    Email_Address: {
      value: previousValue.Email_Address.value,
      isValid: true,
    },
    Organization_Name: {
      value: previousValue.Organization_Name.value,
      isValid: true,
    },
    Street_Address: {
      value: previousValue.Street_Address.value,
      isValid: true,
    },
    First_Name: {
      value: previousValue.First_Name.value,
      isValid: true,
    },
    Last_Name: {
      value: previousValue.Last_Name.value,
      isValid: true,
    },
    password: {
      value: previousValue.password.value,
      isValid: true,
    },
    confirmPassword: {
      value: previousValue.confirmPassword.value,
      isValid: true,
    },
  });

  // field validations
  const basicOnChange = (e) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let fieldvalidation = e.target.getAttribute("fieldvalidation");
    let inputValidate = validateInput(inputValue, fieldvalidation);
    if (name == "EIN") {
      dispatch(resetRegisterdetails());
      dispatch(resetprivacyPolicycheckbox());
      setBasicifo((prestate) => ({
        ...prestate,
        Organization_Name: {
          value: "",
          isValid: true,
        },
        Street_Address: {
          value: "",
          isValid: true,
        },
      }));
      if (inputValue.length == 9) {
            dispatch(
              fetchEinDetails({
                BrowserId:PARTNER_BROWSER_ID.ID,
                EIN: inputValidate.value,
                authorization: PARTNER_AUTH.Authorization,
                successCallback,
                faildCallback,
              })
            );
      }
    }
    if (name == "Street_Address") {
      const callbackVerifiedAddress = (address) => {
        if (
          address?.isValidateAddress != undefined &&
          address.isValidateAddress == "ExactMatch"
        ) {
          setVerifiedAddress((prevState) => ({
            ...prevState,
            ...address,
            ...{
              ss_msg_cls: "ss_success",
              ss_msg: errorMessage.smartyStreetMsg.sucessMsg,
            },
          }));
        } else {
          setVerifiedAddress((prevState) => ({
            ...prevState,
            ...address,
            ...{
              ss_msg_cls: "ss_error",
              ss_msg: errorMessage.smartyStreetMsg.errorMsg,
            },
          }));
        }
      };
      const selectedPartnerDetail = getPartnerDetail?.partnerDetails?.filter(
        (data) => {
          return data.address == inputValue;
        }
      );
      const validateAddress =
        selectedPartnerDetail[0]?.address != "" &&
        selectedPartnerDetail[0]?.city != "" &&
        selectedPartnerDetail[0]?.state != "" &&
        selectedPartnerDetail[0]?.zip != "";
      if (validateAddress) {
        const address = {
          addressLine1: selectedPartnerDetail[0]?.address,
          city: selectedPartnerDetail[0]?.city,
          state: selectedPartnerDetail[0]?.state,
          zipCode: selectedPartnerDetail[0]?.zip,
        };
        dispatch(smartyStreetApi({ address, callbackVerifiedAddress }));
      }
    }
    if (name == "confirmPassword") {
      if (basicinfo.password.value != "") {
        setBasicifo((prevState) => ({
          ...prevState,
          password: {
            value: basicinfo.password.value,
            isValid:validateInput(basicinfo.password.value, "password").isValid,
          },
        }));
      }
    }
    if (name == "password") {
      if (basicinfo.confirmPassword.value != "") {
        setBasicifo((prevState) => ({
          ...prevState,
          confirmPassword: {
            value: basicinfo.confirmPassword.value,
            isValid: validateInput(basicinfo.confirmPassword.value, "password").isValid
          },
        }));
      }
    }
    setBasicifo((preinfo) => ({
      ...preinfo,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }));
  };

  const backtoLogin = () => {
    dispatch(resetRegisterdetails());
    dispatch(resetprivacyPolicycheckbox());
    navigate("/");
  };
  const popupClose = () => {
    dispatch(isPopupOpenReducer(false));
    setIsPopupOpen(false);
  };

  const nextClick = () => {
    setIsPopupOpen(false);
  };
  const successCallback = (data) => {
    dispatch(loaderOpen(false));
    // let address=data?.AdditionalProviderAddress[0]
    let street = [];
    let partnerDetails = [];

    data?.AdditionalProviderAddress?.map((value) => {
      street.push({
        key: value.AddressLine1,
        value: value.AddressLine1,
      });
      partnerDetails.push({
        address: value.AddressLine1,
        zip: value.ZipCode,
        state: value.State,
        city: value.City,
        PhoneNumber: value.PhoneNumber,
        FaxNumber: value.Fax,
      });
    });

    let partnerDetailsData = {
      OrganizationName: data.OrganizationName,
      EIN: basicinfo.EIN.value,
      street: street,
      partnerDetails,
      firstName: basicinfo.First_Name.value,
      lastName: basicinfo.Last_Name.value,
      password:basicinfo.password.value
    };
    dispatch(updatePartnerFormDetails(partnerDetailsData));
  };
  const faildCallback = (ein) => {
  
      dispatch(
          fetchpartnerDetails({
            BrowserId:PARTNER_BROWSER_ID.ID ,
            EIN: ein,
            authorization: PARTNER_AUTH.Authorization,
          })
        );
  };

  // need help msg open function
  const needHelpFun = () => {
    setNeedHelp(true);
  };

  // prepopulate update called
  useEffect(() => {
    let isEINValid = false;
    if (
      basicinfo.EIN.value.length == 0 ||
      (basicinfo.EIN.value.length == 9 &&
        !registrationDetails?.registerData?.displayErrorForEIN)
    ) {
      isEINValid = true;
    }

    if (registrationDetails) {
      setBasicifo((prestate) => ({
        ...prestate,
        Organization_Name: {
          value:
            registrationDetails?.registerData?.partnerDetails?.OrganizationName,
          isValid: true,
        },
        EIN: {
          value: basicinfo.EIN.value,
          isValid: isEINValid,
        },
      }));
    }
  }, [registrationDetails]);
useEffect(()=>{
},[])
  // next button cliked  validations in basic information tap
  function isValidatefun() {
    // return true
    let formvalidate =
      basicinfo.EIN.value != "" &&
      basicinfo.EIN.isValid &&
      basicinfo.Email_Address.value != "" &&
      basicinfo.Email_Address.isValid &&
      basicinfo.Organization_Name.value != "" &&
      basicinfo.Organization_Name.isValid &&
      basicinfo.Street_Address.value != "" &&
      basicinfo.Street_Address.isValid &&
      basicinfo.First_Name.value != "" &&
      basicinfo.First_Name.isValid &&
      basicinfo.Last_Name.value != "" &&
      basicinfo.Last_Name.isValid;
    let passwordValidate =
      basicinfo.password.value != "" &&
      basicinfo.password.isValid &&
      basicinfo.confirmPassword.value != "" &&
      basicinfo.confirmPassword.isValid;

    if (!formvalidate) {
      setBasicifo((prestate) => ({
        ...prestate,
        EIN: {
          value: basicinfo.EIN.value,
          isValid:
            basicinfo.EIN.value.length == 9 &&
            !registrationDetails?.registerData?.displayErrorForEIN
              ? true
              : false,
        },
        Email_Address: {
          value: basicinfo.Email_Address.value,
          isValid:
            basicinfo.Email_Address.value != "" &&
            basicinfo.Email_Address.isValid
              ? true
              : false,
        },
        Organization_Name: {
          value: basicinfo.Organization_Name.value,
          isValid:
            basicinfo.Organization_Name.value != "" &&
            basicinfo.Organization_Name.isValid
              ? true
              : false,
        },
        Street_Address: {
          value: basicinfo.Street_Address.value,
          isValid:
            basicinfo.Street_Address.value != "" &&
            basicinfo.Street_Address.isValid
              ? true
              : false,
        },
        First_Name: {
          value: basicinfo.First_Name.value,
          isValid:
            basicinfo.First_Name.value != "" && basicinfo.First_Name.isValid
              ? true
              : false,
        },
        Last_Name: {
          value: basicinfo.Last_Name.value,
          isValid:
            basicinfo.Last_Name.value != "" && basicinfo.Last_Name.isValid
              ? true
              : false,
        },
        password: {
          value: basicinfo.password.value,
          isValid:
            basicinfo.password.value != "" && basicinfo.password.isValid
              ? true
              : false,
        },
        confirmPassword: {
          value: basicinfo.confirmPassword.value,
          isValid:
            basicinfo.confirmPassword.value != "" &&
            basicinfo.confirmPassword.isValid
              ? true
              : false,
        },
      }));
      toast.error(selectedLanguage?.toastError);
      // return formvalidate;
    } else {
      if (
        (basicinfo.password.value != "" &&
          basicinfo.confirmPassword.value == "") ||
        (basicinfo.password.value == "" &&
          basicinfo.confirmPassword.value != "")
      ){
          setBasicifo((prevState) => ({
            ...prevState,
            password: {
              value: basicinfo.password.value,
              isValid:
                basicinfo.password.value != "" &&
                basicinfo.password.isValid
                  ? true
                  : false,
            },
            confirmPassword: {
              value: basicinfo.confirmPassword.value,
              isValid:
                basicinfo.confirmPassword.value != "" &&
                basicinfo.confirmPassword.isValid
                  ? true
                  : false,
            },
          }));
          toast.error(
            "Please fill all mandatory fields!"
          );
        } else if( basicinfo.password.value != '' &&
           basicinfo.confirmPassword.value !=''){
        if (
          basicinfo.password.value.trim() ===
          basicinfo.confirmPassword.value.trim()
        ) {
          if (passwordValidate) {
            if (registrationDetails.registerData.partnerDetails.allowNext) {
              //basic info details update store
              dispatch(
                basicInformationDetails({ ...basicinfo, ...verifiedAddress })
              );

              return formvalidate && true;
            } else {
              toast.error(
                "Community Partner must be an IRS Registered 501c3 Organization"
              );
              formvalidate = formvalidate && false
            }
          } else {
            setBasicifo((prevState) => ({
              ...prevState,
              password: {
                value: basicinfo.password.value,
                isValid:
                  basicinfo.password.value != "" && basicinfo.password.isValid
                    ? true
                    : false,
              },
              confirmPassword: {
                value: basicinfo.confirmPassword.value,
                isValid:
                  basicinfo.confirmPassword.value != "" &&
                  basicinfo.confirmPassword.isValid
                    ? true
                    : false,
              },
            }));
            toast.error("Create a valid password");
            formvalidate = formvalidate && false
          }
        } else {
          setBasicifo((prestate) => ({
            ...prestate,
            password: {
              value: basicinfo.password.value,
              isValid: false,
            },
            confirmPassword: {
              value: basicinfo.confirmPassword.value,
              isValid: false,
            },
          }));
          toast.error(`Password doesn't match`);
          formvalidate = formvalidate && false
        }
      }else{
        setBasicifo((prestate) => ({
          ...prestate,
          password: {
            value: basicinfo.password.value,
            isValid: false,
          },
          confirmPassword: {
            value: basicinfo.confirmPassword.value,
            isValid: false,
          },
        }));
        toast.error("Password must be minimum 8 characters, at least one number, one special character, one uppercase character and one lowercase character");
      }
  
    }
  }

  function cancelFunction() {
    dispatch(resetRegisterdetails());
    navigate("/");
  }
  contxt.formValidation.isValidate = isValidatefun;
  contxt.cancelfunction.cancelFun = cancelFunction;

  return (
    <>
      <p class="pt-10">{selectedLanguage?.enterYourEIN}</p>
      {/* <p class="pt-2">
        <a href="https://apps.irs.gov/app/eos/" target="_blank">
          <u>{selectedLanguage?.whatIsMyEIN}</u>
        </a>
      </p> */}
      <p class="pt-2">
        <p
          className={style.reg_link}
          onClick={() => {
            setIsPopupOpen(true);
          }}
        >
          <u className="fs-xl">This portal is for Non-Profit Patient Partners only.</u>
        </p>
      </p>
      <div class="container editClass">
        <div class="grid input-fields columns-12 gap-4 gap-y-5 p-8 mb-5 container containerResp ">
          <Input
            type="text"
            id="EIN"
            label={selectedLanguage?.EIN}
            name="EIN"
            value={basicinfo.EIN.value}
            isValid={basicinfo.EIN.isValid}
            onChange={(e) => basicOnChange(e)}
            maxLength="9"
            errorMsg={selectedLanguage?.errorMsg}
            fieldvalidation="EIN"
          />
          <Input
            type="email"
            id="EmailAddress"
            label={selectedLanguage?.emailAddress}
            name="Email_Address"
            value={basicinfo.Email_Address.value}
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.Email_Address.isValid}
            errorMsg={selectedLanguage?.errorMsg}
            fieldvalidation="email"
          />
          <Input
            content={selectedLanguage?.PersonRequestingFirstName}
            type="text_tooltip"
            id="First_Name"
            label={selectedLanguage?.firstName}
            name="First_Name"
            value={basicinfo.First_Name.value}
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.First_Name.isValid}
            errorMsg={
              basicinfo.First_Name.value == "" ||
              basicinfo.First_Name.value.length <= 2
                ? selectedLanguage?.errorMsg
                : selectedLanguage?.FirstNameInvalidCharacters
            }
            fieldvalidation="name"
            maxLength={30}
          />
          <Input
            content={selectedLanguage?.PersonRequestingLastName}
            type="text_tooltip"
            id="Last_Name"
            label={selectedLanguage?.lastName}
            name="Last_Name"
            value={basicinfo.Last_Name.value}
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.Last_Name.isValid}
            errorMsg={
              basicinfo.Last_Name.value == "" ||
              basicinfo.Last_Name.value.length <= 2
                ? selectedLanguage?.errorMsg
                : selectedLanguage?.LastNameInvalidCharacters
            }
            fieldvalidation="name"
            maxLength={30}
          />
          <Input
            type="select"
            id="StreetAddress"
            label={selectedLanguage?.streetAddress}
            name="Street_Address"
            value={basicinfo.Street_Address.value}
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.Street_Address.isValid}
            errorMsg={selectedLanguage?.errorMsg}
            elmentconfig={
              registrationDetails?.registerData?.partnerDetails?.street
            }
            fieldvalidation="address"
          />
          <Input
            type="text"
            id="OrganizationName"
            label={selectedLanguage?.organizationName}
            value={basicinfo.Organization_Name.value}
            name="Organization_Name"
            onChange={(e) => basicOnChange(e)}
            isValid={
              basicinfo.Organization_Name.value != ""
                ? true
                : basicinfo.Organization_Name.isValid
            }
            errorMsg={selectedLanguage?.errorMsg}
            fieldvalidation="name"
            disabled="disabled"
          />
        </div>
        <div className="px-10 mx-2">
        {/* <p className="p-1 ps-3 fs-xl text-center text-theme-1">
           <b> {" CREATE YOUR PASSWORD "}</b>
        </p>
        <p className="p-1 ps-3 fs-xl pt-4 pb-2 text-start text-theme-1">
          <b> {" Password Requirements "}</b>
        </p>
        <div className="row px-3 pt-2">
          <p className=" col-md-6 text-start">
            Cannot contain the user's account name
            <br />
            Must be at least eight characters in length
            <br />
            Contain characters from the following four categories:
            <br />
          </p>
          <p className="col-md-6 text-start">
            -English uppercase characters(A-Z) <br />
            -English lowercase characters(a-z)
            <br />
            -Numeric digit(0 through 9) <br />
            -Non-alphabetic characters(for example:!,$,#,%...) <br />
          </p>
        </div> */}
      </div>
      </div>   
      {/* <div class="container editClass pt-2">
        <div class="grid input-fields columns-12 gap-4 gap-y-5 px-8 mb-5 container containerResp ">
          <Input
            type="password"
            id="Password"
            label={"Password"}
            value={basicinfo.password.value}
            name="password"
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.password.isValid}
            errorMsg={selectedLanguage?.errorMsg}
            fieldvalidation="password"
            // disabled="disabled"
          />
          <Input
            type="password"
            id="confirmPassword"
            label={"Confirm Password"}
            value={basicinfo.confirmPassword.value}
            name="confirmPassword"
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.confirmPassword.isValid}
            errorMsg={selectedLanguage?.errorMsg}
            fieldvalidation="password"
            // disabled="disabled"
          />
        </div>
      </div> */}

      <div
        className={`${stylePassword.basic_container} d-flex justify-content-center mt-5 pt-10`}
      >
        <div className={`${stylePassword.update_page}`}>
          {/* <div className=" d-flex justify-content-center pt-5">
            {" "}
            <img src={Logo} alt="logo" />
          </div> */}
          <p className="p-1 ps-3 fs-xl text-theme-1 d-flex justify-content-center">
           <b> {" CREATE YOUR PASSWORD "}</b>
        </p>
        <p className="p-1 ps-3 fs-xl pt-4 pb-2 text-theme-1 d-flex justify-content-center">
          <b> {" Password Requirements "}</b>
        </p>
          <div className={`${stylePassword.pass_content} d-flex justify-content-center`}>
            <div className="text-start">
              <ul className="pt-3 list-disc">
                <li>Cannot contain the user's account name.</li>
                <li>Must be at least eight characters in length.</li>
                <li>Contain characters from the following four categories:
                <ol className="p-3">
                  <li>English uppercase characters(A-Z)</li>
                  <li>English lowercase characters(a-z)</li>
                  <li>Numeric digit(0 through 9)</li>
                  <li>Non-alphabetic characters(for example:!,$,#,%...)</li>
                </ol>
                </li>
              </ul>
              {/* <p className="pt-3">
                {selectedLanguage?.passwordInstructions1}
                <br />
                {selectedLanguage?.passwordInstructions2}
                <br />
                {selectedLanguage?.passwordInstructions3}
                <br />
              </p> */}
            </div>
            {/* <div className="row p-3">
              <div className={`col-md-10 text-start ${stylePassword.pass_sugg}`}>
                <ol>
                  <li>{selectedLanguage?.condiction1}</li>
                  <li>{selectedLanguage?.condiction2}</li>
                  <li>{selectedLanguage?.condiction3}</li>
                  <li>{selectedLanguage?.condiction4}</li>
                </ol>
                <p>{selectedLanguage?.condiction1}</p>
                <p>{selectedLanguage?.condiction2}</p>
                <p>{selectedLanguage?.condiction3}</p>
                <p>{selectedLanguage?.condiction4} </p>
              </div>
            </div> */}
          </div>
          {/* <div className="container d-flex justify-content-center ">
            <div className={`${stylePassword.input_fields}`}>
            <Input
            type="password"
            id="Password"
            label={"Password"}
            value={basicinfo.password.value}
            name="password"
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.password.isValid}
            errorMsg={selectedLanguage?.errorMsg}
            fieldvalidation="password"
            // disabled="disabled"
          />
            </div>
          </div>
          <div className="container d-flex justify-content-center ">
            <div className={`${stylePassword.input_fields}`}>
            <Input
            type="password"
            id="confirmPassword"
            label={"Confirm Password"}
            value={basicinfo.confirmPassword.value}
            name="confirmPassword"
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.confirmPassword.isValid}
            errorMsg={selectedLanguage?.errorMsg}
            fieldvalidation="password"
            // disabled="disabled"
          />
            </div>
          </div>
          <div className="pt-8 pb-8 d-flex justify-content-center">
            <button className={`btn ${stylePassword.buttons}`}>
              {selectedLanguage?.updatePassword}
            </button>
          </div> */}
        </div>
      </div>
      <div class="editClass text-center " style={{backgroundColor:"whitesmoke", margin: "0px 154px"}}>
        {/* <div></div>
        <div></div> */}
        <div class="container d-flex justify-content-center">
        <div className={`${stylePassword.input_fields}`}>
          <Input
            type="password"
            id="Password"
            label={"Password"}
            value={basicinfo.password.value}
            name="password"
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.password.isValid}
            errorMsg={selectedLanguage?.errorMsg}
            fieldvalidation="password"
            // disabled="disabled"
          />
          </div>
          </div>
          <div class="container d-flex justify-content-center pb-10 mb-5">
        <div className={`${stylePassword.input_fields}`}>
          <Input
            type="password"
            id="confirmPassword"
            label={"Confirm Password"}
            value={basicinfo.confirmPassword.value}
            name="confirmPassword"
            onChange={(e) => basicOnChange(e)}
            isValid={basicinfo.confirmPassword.isValid}
            errorMsg={selectedLanguage?.errorMsg}
            fieldvalidation="password"
            // disabled="disabled"
          />
          </div>
        </div>
      </div>
      {/* {updatePasswordDetails?.passwordData?.loader == true || loader ? <Loader /> : null} */}
      <div className="pt-8">
        <p onClick={backtoLogin} className={`p-3 mr-5 ${style.reg_link}`}>
          <u>{selectedLanguage?.backToLogin}</u>
        </p>
        <br />
        <p onClick={needHelpFun} className={style.reg_link}>
          <u>{selectedLanguage?.needHelp}</u>
        </p>
      </div>
      <Modal
        visible={isPopupOpen}
        // title=''
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        // className='myModal'
        maskClosable={false}
        closable={false}
        width={800}
        centered
      >
        <div className={style.popup_content}>
          <div
            className="font_style modal-content align-items-center justify-content-start p-3"
            style={{ textAlign: "start " }}
          >
            <div className={`${style.registerPopUp}`}>
              <p>Non-Profit Patient Partners may include:</p>
              <ul>
                <li>
                  Social Workers who work with a non-profit charitable
                  organization
                </li>
                <li>
                  Case managers who work with a non-profit charitable
                  organization
                </li>
                <li>
                  Nurses who work with a non-profit charitable organization
                </li>
                <li>
                  Financial Counselors who work with a non-profit charitable
                  organization
                </li>
                <li>
                  Other staff assisting patients who work with a non-profit
                  charitable organization
                </li>
              </ul>
              <p>
                <b>To Register:</b> you must have a valid professional email
                address, and a valid Federal Tax ID/Employer Identification
                Number (EIN) of the charitable non-profit organization you
                represent. Once you submit your registration, you will receive
                an email (typically within five minutes) directing you to a
                website to create your password. You can then log in and begin
                using your portal account.
              </p>
              <p>
                Click Next, to begin the registration process for the Non-Profit
                Patient Portal.
              </p>
              <p>
                Note: This portal is NOT intended for individual patients,
                family members, pharmacy or provider staff. PAF maintains
                separate portals for these user types.
              </p>
            </div>
            <br />
            <br />
            <div className="closed-1 cursor-pointer bottom-0 end-0 w-40 h-12 d-flex align-items-center justify-content-center z-50 me-10">
              <button
                onClick={popupClose}
                className="btn btn-yellow bg-yellow "
              >
                {selectedLanguagePopup?.close}
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        title=""
        open={needHelp}
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={() => {
          setNeedHelp(false);
        }}
        maskClosable={false}
        closable={false}
        centered
        width={850}
      >
        <div>
          <p className="mb-6 Ass_info">Technical Assistance and Information</p>
          <p className="pb-6">
            For portal inquiries or technical issues, please contact the Patient
            Advocate Foundation at 1-866-512-3861 and select option 5.
          </p>
          <p
            className="text-center pb-6 "
            style={{ fontSize: "18px", fontWeight: "700" }}
          >
            Portal User System Requirements
          </p>
          <div className="pb-6">
            <div className="row">
              <div className="col-md-6">
                <p className="pb-2">
                  <b>Internet Explorer 11</b>
                </p>
                <p className="pb-2">
                  <b>Edge (All Versions)</b>
                </p>
                <p className="pb-2">
                  <b>Adobe Reader 9 or higher version</b>
                </p>
              </div>
              <div className="col-md-6">
                <p className="pb-2">
                  <b>Firefox 39 or higher</b>
                </p>
                <p className="pb-2">
                  <b>Google Chrome 40 or higher</b>
                </p>
                <p className="pb-2">
                  <b>File size uploads are limited to 2MB</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <p className="mb-8 pb-6">
          <b>Please note:</b> Cookies must be enabled. Cookies are usually
          enabled but refer to your browser's help documents for instructions on
          how to enable cookies if they are disabled. If cookies are not
          enabled, you won't be able to log in, and will see the log-in page
          repeatedly.
        </p>
        <p>
          Older versions of these browsers, or browsers not listed here, may
          work, however, if you experience any problems, use one of the browsers
          listed above. Each one is free, widely available, and often
          pre-installed on many computers. Also, please note this site may not
          have full functionality when viewed on Internet Explorer or Edge.
        </p>
      </Modal>
    </>
  );
};

export default BasicInfo;
